import { render, staticRenderFns } from "./PurchaseListDialog.vue?vue&type=template&id=55d4d03c&scoped=true"
import script from "./PurchaseListDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseListDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseListDialog.vue?vue&type=style&index=0&id=55d4d03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4d03c",
  null
  
)

export default component.exports